import _isNil from 'lodash/isNil';

// Counts on this page are rendered with a thousands separator ("7 200 / 10 000").
// The separator is left to the active locale rather than hard-coded, so English
// reads "7,200" while French reads "7 200".
export default function formatCount(
  value: number | null | undefined,
  language?: string,
): string {
  if (_isNil(value)) return '-';
  return value.toLocaleString(language);
}
